import { PurchaseContext } from '@on3/api/src';
import { useModal } from '@on3/ui-lib/components/Modal/Provider';
import { useSubscribe } from '@on3/ui-lib/components/Subscription/Provider';
import { TOC } from '@on3/ui-lib/components/Subscription/Templates/TopOfContent';
import { Tracking } from '@on3/ui-lib/components/Tracking';

export const ArticleNonSubscriberAnnualModal = () => {
  const { showModal } = useModal();
  const { osKey, osSiteKey } = useSubscribe();

  return (
    <div>
      <Tracking
        data={{
          offerSetKey: osKey,
          offerSetSiteKey: osSiteKey,
          creativeName: 'article_non_subscriber_annual',
        }}
        event="view_promotion"
      >
        <TOC
          handleJoin={() =>
            showModal(
              'user.join',
              {
                context: PurchaseContext.Article,
              },
              'screen',
            )
          }
          props={{
            'data-display': 'modal',
          }}
        />
      </Tracking>
    </div>
  );
};
